import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Sample,
  SampleCreate,
  SampleUpdate,
} from '../../interfaces/sample.interface';

export const SampleActions = createActionGroup({
  source: 'Sample',
  events: {
    'Complete sample': props<{ jobId: string; sampleId: string }>(),
    'Complete sample success': props<{ sample: Sample }>(),
    'Complete sample failure': props<{ error: HttpErrorResponse }>(),
    'Incomplete sample': props<{ jobId: string; sampleId: string }>(),
    'Incomplete sample success': props<{ sample: Sample }>(),
    'Incomplete sample failure': props<{ error: HttpErrorResponse }>(),
    'Create sample': props<{ jobId: string; sample: SampleCreate }>(),
    'Create sample success': props<{ sample: Sample }>(),
    'Create sample failure': props<{
      error: HttpErrorResponse;
      sample: SampleCreate;
    }>(),
    'Load sample': props<{ jobId: string; sampleId: string }>(),
    'Load sample success': props<{ sample: Sample }>(),
    'Load sample failure': props<{ error: HttpErrorResponse }>(),
    'Load samples': props<{ jobId: string }>(),
    'Load samples success': props<{ samples: Sample[] }>(),
    'Load samples failure': props<{ error: HttpErrorResponse }>(),
    'Admin Load sample': props<{
      orgId: string;
      jobId: string;
      sampleId: string;
    }>(),
    'Admin Load sample success': props<{ sample: Sample }>(),
    'Admin Load sample failure': props<{ error: HttpErrorResponse }>(),
    'Admin Load samples': props<{ orgId: string; jobId: string }>(),
    'Admin Load samples success': props<{ samples: Sample[] }>(),
    'Admin Load samples failure': props<{ error: HttpErrorResponse }>(),
    'Update and complete sample': props<{
      jobId: string;
      sampleId: string;
      sample: SampleUpdate;
    }>(),
    'Update and complete sample success': props<{ sample: Sample }>(),
    'Update and complete sample failure': props<{ error: HttpErrorResponse }>(),
    'Update sample': props<{
      jobId: string;
      sampleId: string;
      sample: SampleUpdate;
    }>(),
    'Update and incomplete sample': props<{
      jobId: string;
      sampleId: string;
      sample: SampleUpdate;
    }>(),
    'Update and incomplete sample success': props<{ sample: Sample }>(),
    'Update and incomplete sample failure': props<{
      error: HttpErrorResponse;
    }>(),
    'Update sample success': props<{ sample: Sample }>(),
    'Update sample failure': props<{
      error: HttpErrorResponse;
      sample: SampleUpdate;
    }>(),
    'Clear Samples': emptyProps(),
  },
});
